import requestInstance from "./requestInstance";

export const createCheckoutSession = (productID, quantity) => {
  return requestInstance.post("/api/v1/payment/create-checkout-session", {
    productID,
    quantity,
  });
};
